export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "notifications_allowed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Job alert has been set up successfully!"])},
        "notifications_denied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Permissions for notifications has been denied!"])}
      },
      "de-DE": {
        "notifications_allowed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Job Alert wurde erfolgreich eingerichtet!"])},
        "notifications_denied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Berechtigung für Benachrichtigungen wurde verweigert!"])}
      }
    }
  })
}
